var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass: "mt-3 justify-content-center",
      attrs: { id: "finastra-close-dropdown" },
    },
    [
      _vm.disableCompleteApplication
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.left",
                  value: {
                    title: _vm.$t("application.messages.applicationDeclined"),
                    disable: _vm.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY,
                  },
                  expression:
                    "{\n      title: $t('application.messages.applicationDeclined'),\n      disable: CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY\n    }",
                  modifiers: { left: true },
                },
              ],
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-sm",
                  attrs: { disabled: "" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("application.actions.completeApplication")
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ]
          )
        : _c("div", { staticClass: "dropleft d-flex flex-row" }, [
            _c(
              "button",
              {
                ref: "completeApplication",
                staticClass: "complete-app split btn btn-primary btn-sm pr-1",
                attrs: {
                  type: "button",
                  "data-toggle": "dropdown",
                  disabled: _vm.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY,
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("application.actions.completeApplicationAs")
                    ) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "complete-app split btn btn-primary btn-sm dropdown-toggle dropdown-toggle-split",
                attrs: {
                  id: "complete-application",
                  type: "button",
                  "data-toggle": "dropdown",
                  disabled: _vm.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY,
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                },
              },
              [
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(_vm.$t("application.actions.toggleDropdown"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown-menu clickable",
                attrs: {
                  id: "finastra-close",
                  "aria-labelledby": "complete-application",
                },
              },
              [
                _vm.showDropdownOption("paid")
                  ? _c(
                      "a",
                      {
                        staticClass: "close-deal dropdown-item clickable",
                        on: {
                          click: function ($event) {
                            return _vm.handleCloseDeal("paid")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("application.filogixStatus.paid")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showDropdownOption("closed")
                  ? _c(
                      "a",
                      {
                        staticClass: "close-deal dropdown-item clickable",
                        on: {
                          click: function ($event) {
                            return _vm.handleCloseDeal("closed")
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("application.filogixStatus.closed"))
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showDropdownOption("declined")
                  ? _c(
                      "a",
                      {
                        staticClass: "close-deal dropdown-item clickable",
                        on: {
                          click: function ($event) {
                            return _vm.handleCloseDeal("declined")
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("application.filogixStatus.declined"))
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showDropdownOption("cancelled")
                  ? [
                      _c("div", { staticClass: "dropdown-divider" }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "dropdown-item clickable btn-danger close-deal text-danger",
                          on: {
                            click: function ($event) {
                              return _vm.handleCloseDeal("cancelled")
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("application.filogixStatus.cancelled")
                            )
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
      _vm._v(" "),
      _c("confirm-submission-modal", {
        ref: "confirmSubmissionModal",
        attrs: {
          "application-id": _vm.applicationId,
          "client-username": _vm.clientUsername,
          "complete-status": _vm.completeStatus,
          "lender-submissions": _vm.lenderSubmissions,
          submitting: _vm.completingApplication,
          "application-completed": _vm.applicationCompleted,
        },
        on: { submit: _vm.submitCloseDeal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }